import type { FaireProductEntity } from "../../entity_types/product";

export const p_43dnn9rgm2: FaireProductEntity = {
  token: "p_43dnn9rgm2",
  type: "product",
  name: '2" Showcase Quality Arrowheads - 50 Quantity',
  brandToken: "b_46yqo0x0y0",
  brandName: "El Paso Saddleblanket",
  imageUrl:
    "https://cdn.faire.com/fastly/5f1f67d0c217d60998fd6046937bad9424c88b4ff2ccce5a0a05a2af87dfe988.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/eeedbf0839b8f8b24103383fde6be752ed0d99994cf2c9efd73dff039214c262.jpeg",
  ],
  priceDollars: 69.28,
  description:
    'Our 2 inch Showcase Quality arrowheads are hand-chipped from genuine agate and other stones, these handcrafted arrowheads are the highest grade available anywhere.\n\nGreat for promotional giveaways, "artifact" making, and most importantly, for sales directly to your customers.\n\nImported.\n\n*As these are hand-chipped, sizes are approximate \n\nEight sizes available ranging from 1" to Large spearhead size 5"-6".',
  tags: [],
  msrpDollars: 138.57,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:54:44.565Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
